exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table th{white-space: nowrap; vertical-align: middle;}\ntable th, table td{font-size: 12px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/email/contact-form/email-contact-form.component.css
// module id = ../../../../../src/app/admin/email/contact-form/email-contact-form.component.css
// module chunks = 39